import {Component} from '@angular/core';
import {Platform, NavParams, ViewController, ModalController, AlertController, PopoverController} from 'ionic-angular';
import {LoadingPage} from '../loading/loading';
import {DropdownDatePage} from '../dropdown-date/dropdown-date';
import {ConstantsProvider} from '../../providers/constants/constants';
import {ConsultationDataProvider} from '../../providers/consultation-data/consultation-data';
import {ConsultationDataParserProvider} from '../../providers/consultation-data-parser/consultation-data-parser';
import {DataProvider} from '../../providers/data/data';
import {DropdownPopoverPage} from '../dropdown-popover/dropdown-popover';

@Component({
  selector: 'page-signature',
  templateUrl: 'signature.html'
})

export class SignaturePage {
  private saveMode = 0;
  private handler;
  private confirmContinue = false;
  private signingMode = 0;

  /** ----- Constructor ----- **/
  constructor(
    private constants: ConstantsProvider,
    private data: DataProvider,
    private consultationData: ConsultationDataProvider,
    private consultationParser: ConsultationDataParserProvider,
    private platform: Platform,
    private params: NavParams,
    private viewCtrl: ViewController,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private popoverCtrl: PopoverController) {

    this.saveMode = this.params.get('saveMode');
    this.handler = this.params.get('handler');

  }

  get phyChoices() {
    return [
      {"phy_name_zh": '-'},
      ...this.constants.physicians
    ]
  }

  /** ----- UI Callbacks ----- **/
  onSignClicked(inIdx, inEvent) {
    this.signingMode = inIdx;
    // 想要開放所有醫師選項給用戶選擇，因為有可能會醫師A替醫師B輸入，以前只能選擇該登入帳號的醫師
    let popover = this.popoverCtrl.create(DropdownPopoverPage, {
      'choices': this.phyChoices.map(item => item['phy_name_zh']),
      'callback': this.signHandler
    });
    popover.present({
      ev: inEvent
    });
  }


  signHandler = (inIdx) => {
    return new Promise<void>(resolve => {
      // first choice is void
      const selectedPhysicians = inIdx === 0 ? 0 : this.phyChoices[inIdx];
      console.log('this.data.accountInfo', this.data.accountInfo);
      console.log('selectedPhysicians', selectedPhysicians);
      if (this.signingMode == 0) {
        this.consultationData.signCons = selectedPhysicians;
      } else if (this.signingMode == 1) {
        this.consultationData.signDisp = selectedPhysicians;
      } else if (this.signingMode == 2) {
        this.consultationData.signAcus = selectedPhysicians;
      }

      resolve();
    });
  };


  onCancelClicked() {

    this.viewCtrl.dismiss();

  }


  async onNextClicked() {
    let checkIfAllSigned = await this.checkIfAllSignatureSigned();
    if (checkIfAllSigned == false) return;
    // prompt for confirmation
    let allClearConfirm = this.alertCtrl.create({
      // title: (this.consultationData.editMode) ? '儲存更新' : '完成診症',
      // subTitle: (this.consultationData.editMode) ? '確認要覆蓋舊的診症記錄嗎？' : '確認要完成這次診症嗎？',
      title: (this.saveMode == 0) ? '儲存更新' : '完成診症',
      subTitle: (this.saveMode == 0) ? '確認要儲存並列為"待定中"嗎？' : '確認要完成這次診症嗎？',
      buttons: [
        {
          text: '取消',
          role: 'cancel'
        },
        {
          text: '確認',
          handler: () => {

            // show loading indicator and upsert consultation
            let loading = this.modalCtrl.create(LoadingPage, {}, {enableBackdropDismiss: false});
            loading.present();
            let params = this.consultationParser.packData();

            // if 'save'
            if (this.saveMode == 0) {
              this.consultationData.saveAsPending(params).then(res => {
                // this.consultationData.clearAll();
                // dismiss loading indicator and then handle response
                this.consultationData.clearAll();
                loading.dismiss();
                this.handler(res).then(() => {
                  this.viewCtrl.dismiss();
                  // if (this.handler != null) this.handler();
                });
              });
            }//save mark as complete
            else if (this.saveMode == 1) {
              this.consultationData.saveAsDone(params).then(res => {
                // this.consultationData.clearAll();
                // dismiss loading indicator and then handle response
                this.consultationData.clearAll();
                loading.dismiss();
                this.handler(res).then(() => {
                  this.viewCtrl.dismiss();
                  // if (this.handler != null) this.handler();
                });
              });
            }
            // else 'confirm'
            else {
              this.consultationData.archive(params).then(res => {
                // dismiss loading indicator and then handle response
                this.consultationData.clearAll();
                loading.dismiss();
                this.handler(res).then(() => {
                  this.viewCtrl.dismiss();
                  // if (this.handler != null) this.handler();
                });
              });
            }
          }
        }
      ],
      enableBackdropDismiss: false
    });
    allClearConfirm.present();

  }


  presentPopover(inIdx, inEvent) {
    let date: any = new Date();
    if (inIdx == 0 && this.consultationData.slBegin != null) {
      date = this.platform.is('ios') ? this.consultationData.slBegin + 'T00:00:00' : this.consultationData.slBegin + ' 00:00:00';
    } else if (inIdx == 1 && this.consultationData.slEnd != null) {
      date = this.platform.is('ios') ? this.consultationData.slEnd + 'T00:00:00' : this.consultationData.slEnd + ' 00:00:00';
    }
    let datePicker = this.popoverCtrl.create(DropdownDatePage, {
      'date': date, 'callback': (inIdx == 0) ? this.onDateBeginChosen : this.onDateEndChosen
    }, {cssClass: 'custom-popover'});
    datePicker.present({
      ev: inEvent
    });
    return;

  }


  onDateBeginChosen = (inDate) => {
    return new Promise<void>(resolve => {

      this.consultationData.slBegin = inDate;
      resolve();
    });
  };


  onDateEndChosen = (inDate) => {

    return new Promise<void>(resolve => {

      this.consultationData.slEnd = inDate;
      resolve();
    });
  };

  async checkIfAllSignatureSigned() {
    return new Promise(async (resolve) => {
      let allClearConfirm = this.alertCtrl.create({
        title: '還未完成所有簽署',
        subTitle: '確認要繼續？',
        buttons: [
          {
            text: '取消',
            handler: () => {
              this.confirmContinue = false;
              resolve(this.confirmContinue);
            },
            role: 'cancel'
          },
          {
            text: '確認',
            handler: () => {
              this.confirmContinue = true;
              resolve(this.confirmContinue);
            }
          }
        ],
        enableBackdropDismiss: false
      });

      if (
        this.consultationData.signCons == -1 ||
        this.consultationData.signDisp == -1 ||
        this.consultationData.signAcus == -1
      ) {
        await allClearConfirm.present();
      } else {
        this.confirmContinue = true;
        resolve(this.confirmContinue);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/signature/signature.ts